import React from 'react';
import GetName from './GetName';


export default class ConsultaHoje extends React.Component {
  constructor() {
    super();

    this.state = {
      componentData: '',
      condition: '2',

    };
  }

  componentDidMount() {

    var today = new Date();
    var birthDate = new Date(this.props.data);
    console.log(birthDate);
    var age = today.getFullYear() - birthDate.getFullYear();
    console.log(age);
    var m = today.getMonth() - birthDate.getMonth();
    console.log(m);
    var d = today.getDate() - birthDate.getDate();
    console.log(d);

    if ((age < 0)) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((age > 0)) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m < 0 ) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((m > 0 ) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d == 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 1 });
    }

    if ((m == 0) && (d > 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d < 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }
    
    }

    render() {
      let {condition} = this.state;
      const renderAuthButton = ()=>{
        if(condition == '1'){
          return <button id="option-PS-Painel-Alerta"><GetName user_id={this.props.user_id}/></button>
        } 
        if(condition == '2'){
          return <button id="option-PS-Painel-Passed"><GetName user_id={this.props.user_id}/></button>
        }
        if(condition == '0'){
          return <button id="RI-Cadastro"><GetName user_id={this.props.user_id}/></button>
        } 
      }
    return (
    <>
      {renderAuthButton()}
    </>
)
}
}